import gql from "graphql-tag";

const FORMSUBMISSION_QUERY = gql`
query getSubmissionById($id:String!){
  submission(id:$id){
    id
    payload
    createdAt
    updatedAt
    form {
      title
      id
    }
  }
}`;
export default FORMSUBMISSION_QUERY;